'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isOptional = function isOptional(val) {
    return true;
};

var isRequired = function isRequired(val) {
    return !!(val === 0 || val);
};

var isEmail = function isEmail(val) {
    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(val);
};

// Known Limitation: US numbers only
var isPhoneNumber = function isPhoneNumber(val) {
    var cleanVal = val.replace(/ /g, '');
    var re = /^(\+? ?1)?\(?(\d{3})\)?[- .]?(\d{3})[- .]?(\d{4})$/;
    return re.test(cleanVal);
};

exports.isOptional = isOptional;
exports.isRequired = isRequired;
exports.isEmail = isEmail;
exports.isPhoneNumber = isPhoneNumber;


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/validation.js
// module id = 212
// module chunks = 2 3